var _circle, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#26C9B5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1991 13.9466V21.2353C21.1991 21.5222 21.113 21.802 20.9552 22.0387L18.9967 24.9514C18.6882 25.4177 17.9206 25.7477 17.2678 25.5037C16.5648 25.267 16.0985 24.4779 16.2491 23.7748L16.6221 21.429C16.6508 21.2137 16.5935 21.02 16.4715 20.8694C16.3495 20.7331 16.1702 20.647 15.9765 20.647H13.028C12.4613 20.647 11.9735 20.4174 11.6865 20.0157C11.4139 19.6283 11.3637 19.1261 11.543 18.6168L13.3078 13.2435C13.5302 12.354 14.4987 11.6294 15.46 11.6294H18.2578C18.7385 11.6294 19.4128 11.7944 19.7213 12.1029L20.6395 12.8131C20.9911 13.0857 21.1991 13.5018 21.1991 13.9466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4799 22.6331H24.2188C25.3308 22.6331 25.7828 22.2027 25.7828 21.1409V13.9311C25.7828 12.8694 25.3308 12.439 24.2188 12.439H23.4799C22.368 12.439 21.916 12.8694 21.916 13.9311V21.1481C21.916 22.2027 22.368 22.6331 23.4799 22.6331Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9823 14.7293V22.018C21.9823 22.3049 21.8962 22.5847 21.7384 22.8215L19.7799 25.7341C19.4714 26.2004 18.7038 26.5304 18.051 26.2865C17.348 26.0497 16.8817 25.2606 17.0323 24.5575L17.4054 22.2117C17.434 21.9965 17.3767 21.8028 17.2547 21.6521C17.1327 21.5158 16.9534 21.4297 16.7597 21.4297H13.8112C13.2445 21.4297 12.7567 21.2002 12.4697 20.7984C12.1971 20.411 12.1469 19.9088 12.3262 19.3995L14.091 14.0262C14.3134 13.1367 15.2819 12.4121 16.2432 12.4121H19.041C19.5217 12.4121 20.196 12.5771 20.5045 12.8856L21.4227 13.5958C21.7743 13.8684 21.9823 14.2845 21.9823 14.7293Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2631 23.4153H25.002C26.114 23.4153 26.566 22.9849 26.566 21.9231V14.7134C26.566 13.6516 26.114 13.2212 25.002 13.2212H24.2631C23.1512 13.2212 22.6992 13.6516 22.6992 14.7134V21.9303C22.6992 22.9849 23.1512 23.4153 24.2631 23.4153Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.9a9c86509940ab3dafa855671c147f07.svg";
export { ForwardRef as ReactComponent };